import React, { Component } from "react";

import { Navbar, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateId: this.props.templateId,
      locationId: this.props.locationId
    };
  }

  // componentDidMount = () => {
  //   console.log(this.props.templateId);
  // };

  render() {
    return (
      <div className="headerContainer">
        <div className="container-fluid">
          <div className="logoContainer">
            <Navbar fixed="top" expand="lg">
              <LinkContainer to="/">
                <Navbar.Brand>
                  <h1>Bowinkles Drive Thru</h1>
                </Navbar.Brand>
              </LinkContainer>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto">
                  <LinkContainer
                    to={`/location/${this.state.locationId}/${this.state.templateId}/menu`}
                  >
                    <Nav.Link>Menu</Nav.Link>
                  </LinkContainer>
                  <LinkContainer
                    to={`/location/${this.state.locationId}/${this.state.templateId}/contact`}
                  >
                    <Nav.Link>Contact</Nav.Link>
                  </LinkContainer>
                </Nav>
                <Nav className="d-flex justify-content-end">
                  {this.state.templateId === "1" ? (
                    <div className="py-1">
                      <a className="telephone" href="tel:9169919996">
                        <i className="fas fa-phone-square-alt">
                          <span>(916) 991-9996</span>
                        </i>
                      </a>
                      <a
                        className="address"
                        href="https://www.google.com/maps/dir/912+Oak+Ln,+Rio+Linda,+CA+95673//@38.6912806,-121.4798521,13z/data=!4m9!4m8!1m5!1m1!1s0x809b27e1c4de7feb:0xc5482a8ef309eae5!2m2!1d-121.4448327!2d38.6912188!1m0!3e0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-map-marked">
                          <span>912 Oak Ln, Rio Linda, CA 95673</span>
                        </i>
                      </a>
                    </div>
                  ) : (
                    <div className="py-1">
                      <a className="telephone" href="tel:9168551111">
                        <i className="fas fa-phone-square-alt">
                          <span>(916) 855-1111</span>
                        </i>
                      </a>
                      <a
                        className="address"
                        href="https://www.google.com/maps/dir/10423+Folsom+Blvd,+Rancho+Cordova,+CA+95670//@38.5907383,-121.3356434,13z/data=!4m9!4m8!1m5!1m1!1s0x809add1bda132e6f:0xe3e2845b2252c6bf!2m2!1d-121.300624!2d38.5906764!1m0!3e0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-map-marked">
                          <span>
                            10423 Folsom Blvd, Rancho Cordova, CA 95670
                          </span>
                        </i>
                      </a>
                    </div>
                  )}
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
